export enum AppLanguage {
	Fr = 'fr',
	En = 'en'
}
